import { cn } from "@/lib/utils";
import type { ReactNode } from "react";
import { Plus } from "lucide-react";

type FeatureCardProps = {
  title: string;
  skeleton?: ReactNode;
  className?: string;
  showExpandIcon?: boolean;
};

export function FeatureCard({ 
  title, 
  skeleton, 
  className,
  showExpandIcon = true,
}: FeatureCardProps) {
  return (
    <div
      className={cn(
        "relative overflow-hidden bg-neutral-100 dark:bg-neutral-900 border border-neutral-200 dark:border-neutral-800",
        className
      )}
    >
      <div className="relative h-64 sm:h-72 md:h-80 overflow-hidden">
        {skeleton}
      </div>
      <div className="p-4 md:p-6 flex items-center justify-between border-t border-neutral-200 dark:border-neutral-800">
        <h3 className="text-base md:text-lg font-semibold text-foreground">
          {title}
        </h3>
        {showExpandIcon && (
          <div className="flex items-center justify-center h-8 w-8 rounded-full bg-neutral-200 dark:bg-neutral-800">
            <Plus className="h-4 w-4 text-muted-foreground" />
          </div>
        )}
      </div>
    </div>
  );
}

type FeatureCardContentProps = {
  children: ReactNode;
  className?: string;
};

export function FeatureCardContent({ children, className }: FeatureCardContentProps) {
  return (
    <div className={cn("p-4 md:p-6", className)}>
      {children}
    </div>
  );
}

type FeatureCardSkeletonProps = {
  children: ReactNode;
  className?: string;
};

export function FeatureCardSkeleton({ children, className }: FeatureCardSkeletonProps) {
  return (
    <div
      className={cn(
        "relative h-full w-full overflow-hidden",
        className
      )}
    >
      {children}
    </div>
  );
}

